import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { DeviceTypesEnum } from "../../common/enums/DeviceTypesEnum";
import { IPageConfigurationAvailableColumns3, PageConfigurationTypeEnum } from "../../services/page-configuration-service/Models";
import PageConfigurationService from "../../services/page-configuration-service/PageConfigurationService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UsePageConfigurationItemsParameters = {
    groupID: number;
    pageConfigurationType: PageConfigurationTypeEnum;
    deviceType?: DeviceTypesEnum
} & BaseUseQueryParameters<IPageConfigurationAvailableColumns3>;


export function usePageConfigurationItems({
    groupID,
    pageConfigurationType,
    deviceType,
    enabled,
    onError,
    onSuccess,
    //refreshSeconds
}: UsePageConfigurationItemsParameters) {
    return useQuery<IPageConfigurationAvailableColumns3, RestError>(
        keys.configurationItems(groupID, pageConfigurationType, deviceType),
        ({ signal }) => {
            return PageConfigurationService.getAvailablePageConfigurationItems3(groupID, pageConfigurationType, deviceType, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            //staleTime: 0,
            //cacheTime: 0,

            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }        
    );
}
